import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

/**
 * Navigation bar component - Shows different options based on user role
 */
const Navbar = () => {
  //remove isAdmin as it is not used in the Navbar component when redeploying to netlify
  const { user, logout } = useAuth();
  const navigate = useNavigate(); // Initialize navigate hook

  /**
   * Handle logout
   */
  const handleLogout = () => {
    logout();
    navigate('/login'); // Use navigate instead of window.location
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo/Brand */}
        <div className="navbar-brand">
          <h2>DeskFlow</h2>
        </div>

        {/* User info and actions */}
        <div className="navbar-actions">
          <span className="user-info">
            <span className="user-name">{user?.name}</span>
            <span className={`user-role-badge ${user?.role?.toLowerCase()}`}>
              {user?.role}
            </span>
          </span>
          <button 
            className="logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;